import React from "react";
import PropTypes from "prop-types";
import * as classes from "./FoodCard.module.css";
import { renderRichText } from "gatsby-source-contentful/rich-text";

const FoodCard = ({ title, content }) => {
  return (
    <div className={classes.cardWrapper}>
      <h3>{title}</h3>
      {content && renderRichText(content)}
    </div>
  );
};

FoodCard.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired
};

export default FoodCard;
